export { default } from './EzLoader.vue';
